// extracted by mini-css-extract-plugin
module.exports = {"column":"shapes_column__9D078","many":"shapes_many__W6iTU","area":"shapes_area__O7S_2","stack":"shapes_stack__G76ty","line":"shapes_line__dwVnw"};